<button mat-button [matMenuTriggerFor]="appMenu"><span [ngClass]="size">{{ horse.name }}</span></button>

<mat-menu #appMenu="matMenu" [overlapTrigger]="false">
  <a [routerLink]="['/pedigree']" [queryParams]="{ h: horse.id }" mat-menu-item>Pedigree</a>
  <a [routerLink]="['/record']" [queryParams]="{ m: horse.id }" mat-menu-item>Production</a>
</mat-menu>
